<template>
  <v-app id="agentCom">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="4">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>
     
      <v-row>
          <v-col cols="4">
            <v-select v-model="param.selectKeuze" :items="selectCodes" item-value="selectCode"  item-text="selectOms" label="On Booking / All"></v-select>
          </v-col>
      </v-row>  

      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Create excel sheet</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      selectCodesSelected: '',
      selectCodes: [],
      submitted: false,
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/ovrz/getKlptParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getKlptParam"
        },
        getKlptParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getKlptParam; 
           res.data.getKlptParam.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getKlptParam.selectKeuzes.forEach(function(select) {
             deze.selectCodes.push(select);
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$axios
        .post("ares/json/ares/task/fin/ovrz/excelExportKlpt1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportKlpt"
          },
          excelExportKlpt: {
            bedr_codes: this.bedrCodesSelected,
            selection: this.param.selectKeuze
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {

            this.submitted = false;
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.excelExportKlpt.text,
              color: res.data.excelExportKlpt.color,
            });

          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
